<template>    
    <div class="py-4 container-fluid">
        <div class="card mb-5" ref="pdfContent">
            <div class="row mb-5 pdf-logo-section">
                <div class="col-lg-12">
                    <div class="card-header p-3 pt-2">
                        <img
                            :src="isLoading ? loadingImageUrl : associationLogoImageSrc"
                            :alt="$t('association.Logo_image')"
                            style="width: 200px;"
                            />  
                        <h6 class="mb-2">{{ animal.associationName }}</h6>
                    </div>
                </div>
                <!-- LEFT: animal overview -->
                <div class="col-lg-4 pdf-animal-details">
                    <div class="card-header p-3 pt-2">
                        <h4>Overzicht afstamming van</h4>
                        <div>
                            <dl class="row mb-0 small">
                                <dt class="col-6 text-muted">Stamboeknummer: </dt><dd class="col-6 line-height-20">{{ animal.studbookNumber }}&nbsp;</dd> 
                                <dt class="col-6 text-muted">Levensnummer: </dt><dd class="col-6 line-height-20">{{ animal.tagNumber }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Landcode: </dt><dd class="col-6 line-height-20">{{ animal.countryCode }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Ras:  </dt><dd class="col-6 line-height-20">{{ animal.breedName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Kleur: </dt><dd class="col-6 line-height-20">{{ animal.colorName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Naam: </dt><dd class="col-6 line-height-20">{{ animal.animalName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geslacht: </dt><dd class="col-6 line-height-20">{{ animal.gender }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geboortedatum: </dt><dd class="col-6 line-height-20">{{ animal.birthDate }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Worpgrootte: </dt><dd class="col-6 line-height-20">{{ animal.litterSize }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal worpen: </dt><dd class="col-6 line-height-20">{{ animal.noParities }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal lammeren: </dt><dd class="col-6 line-height-20">{{ animal.noLambs }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Scrapie: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Zwoeger: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName2 }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Stamboeksectie: </dt><dd class="col-6 line-height-20">{{ animal.studebookSectionDescription }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Status: </dt><dd class="col-6 line-height-20">{{ animal.studebookStatus }}&nbsp;</dd>
                                                                
                                <!-- KEURSTW -->
                                <template v-for="attr in keurstwItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <!-- KEURPNT -->
                                <template v-for="attr in keurpntItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <dt class="col-6 text-muted">Fokker: </dt><dd class="col-6 line-height-20">{{ animal.breederName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Houder: </dt><dd class="col-6 line-height-20">{{ animal.keeperName }}&nbsp;</dd>
                            </dl>
                        </div>
                        <!-- Add Offspring table here-->
                         <div class="offspring-section mt-4" data-hide-pdf>
                            <div class="offspring-title">
                                Nakomelingen:                            
                            </div>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered offspring-table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Stamboeknummer</th>
                                            <th>Levensnummer</th>
                                            <th>Gesl</th>
                                            <th>Worpgrootte</th>
                                            <th>Worpen</th>
                                            <th>Lammeren</th>
                                            <th>Ras</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="offspring in animal.offspring" :key="offspring.animalId">
                                            <td>
                                                <a
                                                    v-if="offspring.animalId"
                                                    :href="`/animal/pedigree/${offspring.animalId}`"
                                                    class="offspring-studbook-link"                                                    
                                                >
                                                    {{ offspring.studbookNumber || '' }}
                                                </a>

                                                <span v-else>
                                                    {{ offspring.studbookNumber || '' }}
                                                </span>
                                            </td>
                                            <td>{{ offspring.tagNumber || '' }}</td>
                                            <td>{{ offspring.gender || '' }}</td>
                                            <td>{{ offspring.litterSize ?? '' }}</td>
                                            <td>{{ offspring.noParities ?? '' }}</td>
                                            <td>{{ offspring.noLambs ?? '' }}</td>
                                            <td>{{ offspring.breed || '' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- RIGHT: pedigree L→R rows with brackets -->
                <div class="col-lg-8 ped-row-right">

                    <!-- ROW 1: FATHER SIDE -->
                    <div class="ped-row mb-5">
                        <!-- LEFT: father card -->
                        <div class="ped-left">
                            <PedigreeCard
                                v-if="pedigree1?.selectedanimal?.father"
                                :node="pedigree1.selectedanimal.father"
                                label="Vader"
                                :id="pedigree1.selectedanimal.father.id"
                            />
                        </div>
                        <!-- RIGHT: father's parents + grandparents -->
                        <div class="ped-right">
                            <!-- FATHER'S FATHER -->
                            <div v-if="pedigree1.selectedanimal.father?.father" class="branch">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1.selectedanimal.father.father"
                                        label="Vader"
                                        :id="pedigree1.selectedanimal.father.father.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandfather's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.father?.father"
                                            :node="pedigree1.selectedanimal.father.father.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.father.father.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandfather's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.father?.mother"
                                            :node="pedigree1.selectedanimal.father.father.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.father.father.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- FATHER'S MOTHER -->
                            <div v-if="pedigree1.selectedanimal.father?.mother" class="branch mt-4">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1.selectedanimal.father.mother"
                                        label="Moeder"
                                        :id="pedigree1.selectedanimal.father.mother.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandmother's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.mother?.father"
                                            :node="pedigree1.selectedanimal.father.mother.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.father.mother.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandmother's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.father?.mother?.mother"
                                            :node="pedigree1.selectedanimal.father.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.father.mother.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ROW 2: MOTHER SIDE -->
                    <div class="ped-row">
                        <!-- LEFT: mother card -->
                        <div class="ped-left">
                            <PedigreeCard
                                v-if="pedigree1?.selectedanimal?.mother"
                                :node="pedigree1.selectedanimal.mother"
                                label="Moeder"
                                :id="pedigree1.selectedanimal.mother.id"
                            />
                        </div>
                        <!-- RIGHT: mother's parents + grandparents -->
                        <div class="ped-right">
                            <!-- MOTHER'S FATHER -->
                            <div v-if="pedigree1.selectedanimal.mother?.father" class="branch">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1.selectedanimal.mother.father"
                                        label="Vader"
                                        :id="pedigree1.selectedanimal.mother.father.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandfather's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.father?.father"
                                            :node="pedigree1.selectedanimal.mother.father.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.mother.father.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandfather's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.father?.mother"
                                            :node="pedigree1.selectedanimal.mother.father.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.mother.father.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- MOTHER'S MOTHER -->
                            <div v-if="pedigree1.selectedanimal.mother?.mother" class="branch mt-4">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1.selectedanimal.mother.mother"
                                        label="Moeder"
                                        :id="pedigree1.selectedanimal.mother.mother.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandmother's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.mother?.father"
                                            :node="pedigree1.selectedanimal.mother.mother.father"
                                            label="Vader"
                                            :id="pedigree1.selectedanimal.mother.mother.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandmother's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1.selectedanimal.mother?.mother?.mother"
                                            :node="pedigree1.selectedanimal.mother.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1.selectedanimal.mother.mother.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
        <div class="row">
            <div class="col-12 col-sm-12 mt-2">
                <router-link v-if="!isEmbedded" to="/animal" class="btn btn-sm bg-gradient-danger float-start  ms-2">{{ $t('common.Cancel') }}</router-link>
                <button v-on:click="downloadPdf" class="btn btn-sm bg-gradient-success mr-2 me-2 float-end">{{ $t('common.Download_PDF') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import { defineComponent, h } from 'vue';
import loadingImageUrl from '@/assets/img/LoadingImage.gif'
import noImageUrl from '@/assets/no-image.png'
import html2canvas from 'html2canvas';
import { useRouter } from 'vue-router';

const PedigreeCard = defineComponent({
  name: 'PedigreeCard',
  props: {
    node: { type: Object, required: true },
    label: { type: String, default: '' },
    level: { type: Number, default: 0 },
    id: { type: String, required: true },

    // true = 10 columns in one row
    // false = 5 + 5 columns in two rows
    wide: {
        type: Boolean,
        default: false
    }
  },
  setup(props) {
    const router = useRouter()

    const goToPreview = () => {
      if (props.id) {
        router.push({ 
            name: 'Preview Animal', 
            params: { id: props.id },
            query: { call: 'pedigree' }
        })
      }
    }

    return () =>
      h('div', { class: ['card','card-node','border-0','shadow-sm','text-nowrap'] }, [
        h('div', {
          class: ['card-header','card-header-custom','py-1','px-2','fw-semibold', props.node?.gender === 'M' ? 'bg-male text-white' : 'bg-female text-white'],
           style: { fontSize: '18px !important', padding: '11px !important', paddingLeft: '21px !important' }
        }, props.label || (props.node?.gender === 'M' ? 'Vader' : 'Moeder'),
            h(
                'a',
                {
                    class: 'ms-3 float-end', 'data-hide-pdf': 'true',
                    title: 'Voorbeeld',
                    style: { cursor: 'pointer' },
                    onClick: goToPreview
                },
                [
                    h('i', {
                    class: 'material-symbols-rounded opacity-10 text-white',
                    style: { fontSize: '1.2rem' },
                    ariaHidden: 'true'
                    }, 'table_eye')
                ]
            )
        ),
        h('div', { class: 'card-body p-2 small' }, [

        // single row: studbook | tag | country
        h('div', { class: 'fw-semibold mb-1' }, [            
            props.node?.id
                    ? h('a',
                        {
                            href: `/animal/pedigree/${props.node.id}`,                        
                            style: {
                                color: '#0f8d09',
                                textDecoration: 'none'
                            }
                        },
                        props.node?.studbooknumber ?? '—'
                    )
                    : (props.node?.studbooknumber ?? '—'),    
            ' | ',    
            props.node?.tagnumber || '—',
            ' | ',
            props.node?.countrycode || '—'
        ]),
           
        h('div', { class: 'fw-semibold mb-1' }, [
            h('span', { class: 'fw-bold' }, 'Naam: '),
            props.node?.name || '—'
        ]),

        props.wide
            ? h('div', { class: 'fw-semibold mb-1 wide-details' }, [

                h('span', { class: 'fw-bold' }, 'Geb: '),
                props.node?.birthdate || '—',

                ' | ',

                props.node?.genotype || '—',

                ' | ',

                h('span', { class: 'fw-bold' }, 'Worpgrootte: '),
                props.node?.siblings ?? '—',

                ' | ',

                h('span', { class: 'fw-bold' }, 'Worpen: '),
                props.node?.nobirths ?? '—',

                ' | ',

                h('span', { class: 'fw-bold' }, 'Lammeren: '),
                props.node?.nolambs ?? '—'

            ])
            : h('div', {}, [

                // Birthdate
                h('span', { class: 'fw-bold' }, 'Geb: '),
                props.node?.birthdate || '—',

                ' | ',

                props.node?.genotype || '—',

                // Worpgrootte | Worpen | Lammeren
                h('div', { class: 'fw-semibold mb-1' }, [

                    h('span', { class: 'fw-bold' }, 'Worpgrootte: '),
                    props.node?.siblings ?? '—',

                    ' | ',

                    h('span', { class: 'fw-bold' }, 'Worpen: '),
                    props.node?.nobirths ?? '—',

                    ' | ',

                    h('span', { class: 'fw-bold' }, 'Lammeren: '),
                    props.node?.nolambs ?? '—'

                ])

            ]),
        
                
        h('table', {
            class: ['table', 'table-sm', 'table-bordered', 'text-center', 'mt-2', 'keurpunten-table',
                    props.wide ? 'keurpunten-wide' : 'keurpunten-normal']
        }, [
            h('tbody', {}, [

                // =====================================================
                // WIDE CARD
                // 10 columns in ONE row
                // HF HO NE VH MH AH BW ST HV AV
                // =====================================================

                props.wide
                    ? h('tr', {}, [
                        h('th', { class: 'bg-light text-dark' }, 'HF'),
                        h('th', { class: 'bg-light text-dark' }, 'HO'),
                        h('th', { class: 'bg-light text-dark' }, 'NE'),
                        h('th', { class: 'bg-light text-dark' }, 'VH'),
                        h('th', { class: 'bg-light text-dark' }, 'MH'),
                        h('th', { class: 'bg-light text-dark' }, 'AH'),
                        h('th', { class: 'bg-light text-dark' }, 'BW'),
                        h('th', { class: 'bg-light text-dark' }, 'ST'),
                        h('th', { class: 'bg-light text-dark' }, 'HV'),
                        h('th', { class: 'bg-light text-dark' }, 'AV')
                    ])
                    : h('tr', {}, [
                        h('th', { class: 'bg-light text-dark' }, 'HF'),
                        h('th', { class: 'bg-light text-dark' }, 'HO'),
                        h('th', { class: 'bg-light text-dark' }, 'NE'),
                        h('th', { class: 'bg-light text-dark' }, 'VH'),
                        h('th', { class: 'bg-light text-dark' }, 'MH')
                    ]),

                props.wide
                    ? h('tr', {}, [
                        h('td', {}, props.node?.keurPunten?.HF || '—'),
                        h('td', {}, props.node?.keurPunten?.HO || '—'),
                        h('td', {}, props.node?.keurPunten?.NE || '—'),
                        h('td', {}, props.node?.keurPunten?.VH || '—'),
                        h('td', {}, props.node?.keurPunten?.MH || '—'),
                        h('td', {}, props.node?.keurPunten?.AH || '—'),
                        h('td', {}, props.node?.keurPunten?.BW || '—'),
                        h('td', {}, props.node?.keurPunten?.ST || '—'),
                        h('td', {}, props.node?.keurPunten?.HV || '—'),
                        h('td', {}, props.node?.keurPunten?.AV || '—')
                    ])
                    : h('tr', {}, [
                        h('td', {}, props.node?.keurPunten?.HF || '—'),
                        h('td', {}, props.node?.keurPunten?.HO || '—'),
                        h('td', {}, props.node?.keurPunten?.NE || '—'),
                        h('td', {}, props.node?.keurPunten?.VH || '—'),
                        h('td', {}, props.node?.keurPunten?.MH || '—')
                    ]),

                // =====================================================
                // NORMAL CARD - SECOND ROW
                // AH BW ST HV AV
                // =====================================================

                !props.wide
                    ? h('tr', {}, [
                        h('th', { class: 'bg-light text-dark' }, 'AH'),
                        h('th', { class: 'bg-light text-dark' }, 'BW'),
                        h('th', { class: 'bg-light text-dark' }, 'ST'),
                        h('th', { class: 'bg-light text-dark' }, 'HV'),
                        h('th', { class: 'bg-light text-dark' }, 'AV')
                    ])
                    : null,

                !props.wide
                    ? h('tr', {}, [
                        h('td', {}, props.node?.keurPunten?.AH || '—'),
                        h('td', {}, props.node?.keurPunten?.BW || '—'),
                        h('td', {}, props.node?.keurPunten?.ST || '—'),
                        h('td', {}, props.node?.keurPunten?.HV || '—'),
                        h('td', {}, props.node?.keurPunten?.AV || '—')
                    ])
                    : null

            ])
        ]),
        
        ])
      ])
  }
})


const PedigreeCardNoData = defineComponent({
  name: 'PedigreeCardNoData',
  props: { node: { type: Object, required: true }, label: { type: String, default: '' }, level: { type: Number, default: 0 } },
  setup(props) {
    return () =>
      h('div', { class: ['card','card-node','border-0','shadow-sm','text-nowrap'] }, [
        h('div', {
          class: ['card-header','card-header-custom','py-1','px-2','fw-semibold', props.label === 'Vader' ? 'bg-male text-white' : 'bg-female text-white'],
           style: { fontSize: '18px !important', padding: '4px 4px 4px 21px !important' }
        }, props.label || (props.node?.gender === 'M' ? 'Vader' : 'Moeder')),
        h('div', { class: 'card-body p-2 small' }, [
        
        // single row: studbook | tag | country
        h('div', { class: 'fw-semibold mb-1' }, [
            h('span', { class: 'fw-bold' }, 'Geen gegevens gevonden')
        ]),
        ])
      ])
  }
})

/* ============================================================ */

export default {
    name: 'Pedigree_page',    
    components: { PedigreeCard, PedigreeCardNoData },
    data() {
        return {            
            animalId: '',
            associationLogoImageSrc: noImageUrl,
            isLoading: false,
            loadingImageUrl,
            animal: { keurstw: { items: [] }, keurpnt : { items: [] } },
            gets: [],            
            pedigree1: {  
                selectedanimal: {
                    id: 'TAG-0001',
                    name: 'De Hoop Willemien',
                    father: {
                        studbooknumber: '00GDA-92231',
                        tagnumber: '100059592231',
                        countrycode: 'NL',
                        name: 'Vader A',
                        birthdate: '23-10-2025',
                        siblings: 1,
                        gender: 'M',
                        id: 'TAG-1001',
                        genotype: 'ARR/ARR',
                        nobirths: 3,
                        nolambs: 6,                        
                        father: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'M',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6
                        },
                        mother: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'F',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6, 
                        }
                    },
                    mother: {
                        studbooknumber: '00GDA-92231',
                        tagnumber: '100059592231',
                        countrycode: 'NL',
                        name: 'Moeder B',
                        birthdate: '23-10-2025',
                        siblings: 1,
                        gender: 'M',
                        id: 'TAG-1001',
                        genotype: 'ARR/ARR',
                        nobirths: 3,
                        nolambs: 6,                        
                        father: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'M',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6
                        },
                        mother: { 
                            studbooknumber: '00GDA-92231',
                            tagnumber: '100059592231',
                            countrycode: 'NL',
                            name: 'Vader A',
                            birthdate: '23-10-2025',
                            siblings: 1,
                            gender: 'F',
                            id: 'TAG-1001',
                            genotype: 'ARR/ARR',
                            nobirths: 3,
                            nolambs: 6, 
                        }
                    }
                }
            }
        }
    },
    computed: {
        isEmbedded() {
            return this.$route.query.embed === 'true';
        },

        keurstwItems() {
        return (this.animal && this.animal.keurstw && Array.isArray(this.animal.keurstw.items))
            ? this.animal.keurstw.items
            : [];
        },
        keurpntItems() {
        return (this.animal && this.animal.keurpnt && Array.isArray(this.animal.keurpnt.items))
            ? this.animal.keurpnt.items
            : [];
        }
    },
    async mounted() {        
        try {            
            this.animalId = this.$route.params.id;            
            console.log(this.animalId);
            await this.fetchAnimalPedigree(this.animalId);
            
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
    },    
    methods: {   
        coercePedigree(input) {
             if (!input) return null;

            // already object
            if (typeof input === 'object') {
                return input;
            }

            // JSON string
            if (typeof input === 'string') {
                try {
                    const parsed =
                        typeof input === 'string'
                            ? JSON.parse(input)
                            : input;

                    return parsed?.pedigree ?? parsed;
                } catch (err) {
                    console.error('Invalid pedigree JSON:', err);
                    return null;
                }
            }

            return null;
        }, 
        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        },
        normalizeAnimalData(raw) {
            const a = raw || {};
            const safeItems = (group) => (group && Array.isArray(group.items)) ? group.items : [];
            return {
                ...a,
                keurstw: { items: safeItems(a.keurstw) },
                keurpnt: { items: safeItems(a.keurpnt) }
            };
        },        
        async fetchAnimalPedigree(animalId) {
            try {
                this.isLoading = true;
                this.$store.commit('setShowLoading', true);

                const response = await axios.get("Animal/getpedigree", {
                                params: {
                                    animalId
                                }})

                this.gets = response.data;

                if (this.gets.success) {   
                    //console.log('here');
                    //this.animal = this.gets.data;
                    this.animal = this.normalizeAnimalData(this.gets.data);                    
                    //this.animal.logoDataUrl

                    let logoSrc = this.animal?.logoDataUrl || '';
                    if (!logoSrc && this.animal?.logoBase64 && this.animal?.contentType?.startsWith('image/')) {
                        logoSrc = `data:${this.animal.contentType};base64,${this.animal.logoBase64}`;
                    }

                    this.associationLogoImageSrc = logoSrc || noImageUrl;  
                    this.isLoading = false;   
                    
                    try {
                        this.pedigree1 = this.coercePedigree(this.animal?.pedigree);
                        //console.log('parsed pedigree:', this.pedigree1);
                    } catch (err) {
                        console.error('coercePedigree error:', err);
                    }                    
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }  finally {
                this.isLoading = false;
                this.$store.commit('setShowLoading', false);
            }      
        },   
        async downloadPdf() {

            const root = this.$refs.pdfContent;

            if (!root)
                return;

            await this.$nextTick();

            // PDF ONLY CLASS
            root.classList.add('pdf-lower-selected-animal');

            // HIDE ELEMENTS THAT SHOULD NOT APPEAR IN PDF
            const hidden = [];

            root.querySelectorAll('[data-hide-pdf]').forEach(el => {
                hidden.push({ el, display: el.style.display});
                el.style.display = 'none';
            });

            // SAVE ORIGINAL OVERFLOW
            const oldOverflow = root.style.overflow;

            try {
                // ALLOW FULL CONTENT
                root.style.overflow = 'visible';

                // Wait for the PDF-only layout changes
                await this.$nextTick();

                // Give browser a moment to recalculate layout
                await new Promise(resolve => requestAnimationFrame(resolve));

                // CAPTURE FULL CONTENT SIZE
                const fullWidth = root.scrollWidth;
                const fullHeight = root.scrollHeight;

                // HTML -> CANVAS
                const canvas = await html2canvas(root, {
                    backgroundColor: '#ffffff',
                    useCORS: true,
                    scale: 2,
                    width: fullWidth,
                    height: fullHeight,
                    windowWidth: fullWidth,
                    windowHeight: fullHeight
                });

                // CREATE IMAGE
                const imgData = canvas.toDataURL('image/png');

                // CREATE A4 LANDSCAPE PDF
                const pdf = new jsPDF({
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4'
                });

                const pageW = pdf.internal.pageSize.getWidth();
                const pageH = pdf.internal.pageSize.getHeight();
                const imgW = canvas.width;
                const imgH = canvas.height;

                // SCALE TO FIT A4
                const scale = Math.min(
                    pageW / imgW,
                    pageH / imgH
                );

                const renderW = imgW * scale;
                const renderH = imgH * scale;

                // CENTER IMAGE
                const x = (pageW - renderW) / 2;
                const y = 5;

                // ADD IMAGE
                pdf.addImage(
                    imgData,
                    'PNG',
                    x,
                    y,
                    renderW,
                    renderH
                );

                // SAVE
                pdf.save('Pedigree.pdf');

            }
            finally {
                // RESTORE ORIGINAL LAYOUT
                root.style.overflow = oldOverflow;

                hidden.forEach(({ el, display }) => {
                    el.style.display = display;
                });

                // Remove PDF-only positioning
                root.classList.remove(
                    'pdf-lower-selected-animal'
                );
            }
        },
        async downloadPdf1() {
            const root = this.$refs.pdfContent;
            if (!root) return;

            await this.$nextTick();

            // Grab existing, rendered DOM parts (no template changes needed)
            const headerEl  = root.querySelector('.row .col-lg-12 .card-header');
            const leftEl    = root.querySelector('.col-lg-4');   // left overview column
            const rightEl   = root.querySelector('.col-lg-8');   // pedigree column (right)

            if (!headerEl || !leftEl || !rightEl) {
                console.warn('Could not find required sections for PDF.');
                return;
            }

            // ---- 1) Build hidden staging area with two page-sized containers ----
            const staging = document.createElement('div');
            staging.style.position = 'fixed';
            staging.style.left = '-10000px';
            staging.style.top = '0';
            staging.style.width = '1122px';   // A4 landscape at ~96dpi
            staging.style.zIndex = '-1';

            // page factory
            const makePage = () => {
                const page = document.createElement('div');
                page.className = 'pdf-page a4-landscape';
                page.style.width = '1122px';
                page.style.minHeight = '793px';  // A4 landscape height at ~96dpi
                page.style.padding = '16px';
                page.style.boxSizing = 'border-box';
                page.style.background = '#ffffff';
                return page;
            };

            const page1 = makePage();
            const page2 = makePage();

            // Clone current rendered DOM (data already applied)
            const headerClone = headerEl.cloneNode(true);
            const leftClone   = leftEl.cloneNode(true);
            const rightClone  = rightEl.cloneNode(true);

            // Hide anything marked for PDF hiding inside clones
            const hideMarked = (root) => {
                if (!root) return;                
                root.querySelectorAll('[data-hide-pdf]').forEach(n => {
                    n.style.display = 'none';
                    // optionally: n.style.visibility = 'hidden';
                });
            };

            hideMarked(headerClone);
            hideMarked(leftClone);
            hideMarked(rightClone);

            // Assemble pages
            page1.appendChild(headerClone);
            page1.appendChild(leftClone);

            page2.appendChild(rightClone);

            staging.appendChild(page1);
            staging.appendChild(page2);
            document.body.appendChild(staging);

            // ---- 2) Snapshot each page separately ----
            const toCanvas = (el) =>
                html2canvas(el, {
                backgroundColor: '#ffffff',
                useCORS: true,
                scale: 2,
                windowWidth: el.scrollWidth || 1122,
                windowHeight: el.scrollHeight || 793,
                });

            const [canvas1, canvas2] = await Promise.all([toCanvas(page1), toCanvas(page2)]);
            const img1 = canvas1.toDataURL('image/png');
            const img2 = canvas2.toDataURL('image/png');

            // ---- 3) Compose the PDF (A4 landscape) ----
            const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
            const pageW = pdf.internal.pageSize.getWidth();
            const pageH = pdf.internal.pageSize.getHeight();

            const addImageFullPage = (src, canvas) => {
                const imgW = canvas.width;
                const imgH = canvas.height;
                const imgRatio = imgW / imgH;
                const pageRatio = pageW / pageH;

                let renderW = pageW, renderH = pageH;
                if (imgRatio > pageRatio) {
                renderW = pageW;
                renderH = pageW / imgRatio;
                } else {
                renderH = pageH;
                renderW = pageH * imgRatio;
                }
                const x = (pageW - renderW) / 2;
                const y = (pageH - renderH) / 2;
                pdf.addImage(src, 'PNG', x, y, renderW, renderH);
            };

            addImageFullPage(img1, canvas1);
            pdf.addPage();
            addImageFullPage(img2, canvas2);

            // ---- 4) Cleanup & save ----
            document.body.removeChild(staging);
            pdf.save('Pedigree.pdf');
        },     
    }
}
</script>
<style scoped>

/* GENERAL */
.line-height-20{
    line-height:20px;
}

/* PDF PAGE */
.pdf-page.a4-landscape{
    width:1122px;
    min-height:793px;
    padding:20px;
    box-sizing:border-box;
    background:#fff;
}


/* NO DATA */
.no-data-box{
    border:2px solid red;
    padding:1rem;
    border-radius:6px;
    color:red;
    text-align:center;
    font-weight:500;
}

/* CARD COLORS */
:global(.bg-male){
    background:#4e61d3 !important;
}

:global(.bg-female){
    background:#d63384 !important;
}


/* =========================================================
   NORMAL PEDIGREE CARDS
   Root + middle generation remain 320px.
========================================================= */
.card-node{
    width:320px;
    min-width:320px;
    max-width:320px;
    box-sizing:border-box;
}


/* =========================================================
   LAST / RIGHT-MOST GENERATION ONLY
   Stretch ONLY the cards inside .child.
   
   DO NOT change .child itself.
========================================================= */
.child > .card-node{
    width:560px;
    min-width:560px;
    max-width:560px;
    box-sizing:border-box;
}

/* KEURPUNTEN TABLE */
.keurpunten-table{
    width:100%;
    table-layout:fixed;
    border-collapse:collapse;
    margin-bottom:0;
}

.keurpunten-table th,
.keurpunten-table td{
    width:10%;
    padding:3px 4px !important;
    font-size:12px !important;
    text-align:center;
    white-space:nowrap;
    vertical-align:middle;
}


/* ROOT ROW */
.ped-row{
    display:flex;
    align-items:center;
    gap:80px;
    margin-bottom:50px;
}

/* ROOT / LEFT SIDE */
.ped-left{
    position:relative;
    display:flex;
    align-items:center;
    justify-content:center;
}

/* Root -> generation 2 connector */
.ped-left::after{
    content:"";
    position:absolute;

    right:-43px;
    top:50%;

    width:40px;
    height:2px;

    background:#d9dee3;

    transform:translateY(-50%);
}

/* RIGHT SIDE */
.ped-right{
    position:relative;

    display:flex;
    flex-direction:column;

    gap:40px;
}

/* MAIN VERTICAL CONNECTOR */
.ped-right::before{
    content:"";

    position:absolute;

    left:-40px;

    top:50%;
    bottom:50%;

    width:2px;
    height:calc(100% - 110px);

    background:#d9dee3;

    transform:translateY(-50%);
}

/* BRANCH */
.branch{
    display:flex;
    align-items:center;
    gap:60px;
}

/* PARENT / MIDDLE GENERATION */
.parent{
    position:relative;

    display:flex;
    align-items:center;
    justify-content:center;
}


/* Middle generation -> last generation connector */
.parent::after{
    content:"";

    position:absolute;

    right:-60px;
    top:50%;

    width:60px;
    height:2px;

    background:#d9dee3;

    transform:translateY(-50%);
}

/* CHILDREN / LAST GENERATION CONTAINER */
.children{
    position:relative;

    display:flex;
    flex-direction:column;

    gap:26px;

    padding-left:60px;
}

/* VERTICAL LINE BETWEEN LAST GENERATION CARDS */
.children::before{
    content:"";

    position:absolute;

    left:0;

    top:50%;
    bottom:50%;

    width:2px;
    height:calc(100% - 90px);

    background:#d9dee3;

    transform:translateY(-50%);
}

/* =========================================================
   CHILD
   IMPORTANT:
   Keep original width/layout.
   Do NOT stretch .child.
========================================================= */
.child{
    position:relative;

    display:flex;
    align-items:center;

    min-height:120px;
}


/* Connector from vertical spine -> last card */
.child::before{
    content:"";

    position:absolute;

    left:-60px;
    top:50%;

    width:60px;
    height:2px;

    background:#d9dee3;

    transform:translateY(-50%);
}

/* REMOVE OLD CONNECTOR SYSTEM */
.ped-mid,
.branch-spine,
.arm,
.to-mid{
    display:none !important;
}

/* RESPONSIVE */
@media (max-width:1200px){
    .ped-row{
        flex-direction:column;
        align-items:flex-start;
        gap:30px;
    }

    .ped-right{
        gap:24px;
    }

    .branch{
        flex-direction:column;
        align-items:flex-start;
        gap:20px;
    }

    /* Hide connectors on smaller screens */
    .ped-left::after,
    .ped-right::before,
    .parent::after,
    .children::before,
    .child::before{
        display:none;
    }

    .children{
        padding-left:0;
    }

    /* All cards become responsive */
    .card-node{
        width:100%;
        min-width:100%;
        max-width:100%;
    }

    /* Last generation also follows responsive width */
    .child > .card-node{
        width:100%;
        min-width:100%;
        max-width:100%;
    }

    /* Keep all 10 columns in one row */
    .keurpunten-table{
        width:100%;
        table-layout:fixed;
    }

    .keurpunten-table th,
    .keurpunten-table td{
        padding:2px !important;
        font-size:11px !important;
    }
}


/* VERY SMALL SCREENS */
@media (max-width:600px){
    .keurpunten-table th,
    .keurpunten-table td{
        padding:2px 1px !important;
        font-size:10px !important;
    }
}

/* OFFSPRING SECTION */
.offspring-section{
    width:100%;
    margin-top:20px;
    box-sizing:border-box;
}

/* OFFSPRING TITLE */
.offspring-title{
    width:100%;
    border-bottom:none;
    padding:4px 0;
    font-weight:600;
    font-size:16px;
    min-height:28px;
    box-sizing:border-box;
}

.offspring-title .text-muted{
    font-weight:400;
    margin-left:80px;
}

/* TABLE CONTAINER */
.offspring-section .table-responsive{
    width:100%;
    max-width:100%;
    overflow-x:hidden !important;
    box-sizing:border-box;
}

/* OFFSPRING TABLE */
.offspring-table{
    width:100%;
    max-width:100%;
    table-layout:fixed;
    border-collapse:collapse;
    border:1px solid #000 !important;
    font-size:12px;
    margin:0 !important;
    box-sizing:border-box;
}

/* TABLE CELLS */
.offspring-table th,
.offspring-table td{
    border:1px solid #000 !important;
    padding:3px 5px !important;
    height:20px;
    vertical-align:middle;
    box-sizing:border-box;
    white-space:nowrap;
    overflow:hidden;
}

/* TABLE HEADER */
.offspring-table th{
    background:#e2efda;
    font-weight:500;
    text-align:left;
}

/* COLUMN WIDTHS Total = 100% */
/* 1. Stamboeknummer */
.offspring-table th:nth-child(1),
.offspring-table td:nth-child(1){
    width:22%;
}

/* 2. Levensnummer */
.offspring-table th:nth-child(2),
.offspring-table td:nth-child(2){
    width:20%;
}

/* 3. Gesl */
.offspring-table th:nth-child(3),
.offspring-table td:nth-child(3){
    width:7%;
    text-align:center;
}

/* 4. Worpgrootte */
.offspring-table th:nth-child(4),
.offspring-table td:nth-child(4){
    width:14%;
    text-align:center;
}

/* 5. Worpen */
.offspring-table th:nth-child(5),
.offspring-table td:nth-child(5){
    width:9%;
    text-align:center;
}

/* 6. Lammeren */
.offspring-table th:nth-child(6),
.offspring-table td:nth-child(6){
    width:12%;
    text-align:center;
}

/* 7. Ras */
.offspring-table th:nth-child(7),
.offspring-table td:nth-child(7){
    width:16%;
}

/* EMPTY OFFSPRING */
.offspring-empty{
    font-size:12px;
    color:#777;
    padding:5px;
}

/* SMALL SCREEN Keep table inside the available width. */
@media (max-width:600px){
    .offspring-table{
        font-size:11px;
    }

    .offspring-table th,
    .offspring-table td{
        padding:2px 3px !important;
    }
}

/* PDF ONLY - LOWER SELECTED ANIMAL INFORMATION */
/* Logo only - move DOWN */
.pdf-lower-selected-animal .pdf-logo-section > .col-lg-12 {
    position: relative;
    top: 180px;
}

/* Selected animal details - move DOWN */
.pdf-lower-selected-animal .pdf-animal-details {
    position: relative;
    top: 180px;
}

/* Pedigree - move UP */
.pdf-lower-selected-animal .ped-row-right {
    position: relative;
    top: -100px;
}

.offspring-studbook-link {
    color: rgb(15, 141, 9); 
    text-decoration: none;
}
</style>